<template>
<h1><font-awesome-icon icon="battery-full" /></h1>
<u>Energiestatus</u>
<br>
<br>
Gateway: <font-awesome-icon icon="plug" />
<br><br>
Feinstaubsensor: <font-awesome-icon icon="plug" />
<br><br>
<div v-if="(sio_bat=='bitte beobachten')||(sio_bat=='ok')">7in1-Sensor: <b>
<font-awesome-icon v-if="sio_bat=='ok'" icon="battery-full" />
<font-awesome-icon v-else icon="battery-empty" />
</b></div>
<br>
<div v-if="(lightning_bat=='bitte beobachten')||(lightning_bat=='ok')">Gewittersensor: <b>
<font-awesome-icon v-if="lightning_bat=='ok'" icon="battery-full" />
<font-awesome-icon v-else icon="battery-empty" />
</b></div>
</template>

<script>

export default {
  name: 'BatteryStatus',
  props: {
    sio_bat: String,
    lightning_bat: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
